import React from "react";
import Header from '../Header/Header';
import Footer from "../Header/Footer";

const AboutUs = () => {
  const aboutImage = "/images/matriimg.jpg"; // ✅ Image from public folder

  return (
    <div>
      <Header/>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "60px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          width: "90%",
          maxWidth: "600px",
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          overflow: "hidden",
        }}
      >
        {/* Top Image */}
        <img
          src={aboutImage}
          alt="About Us"
          style={{ width: "100%", height: "300px", objectFit: "cover" }}
        />

        {/* Main Heading */}
        <h2
          style={{
            textAlign: "center",
            margin: "15px 0 5px 0",
            color: "#2c3e50",
          }}
        >
          Find Your Right Match
        </h2>

        {/* Small Heading */}
        <h4
          style={{
            textAlign: "center",
            margin: "0 0 15px 0",
            color: "#3d4142ff",
            fontWeight: "normal",
          }}
        >
          About Us
        </h4>

        {/* Content */}
        <div
          style={{
            padding: "15px",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          <p>
            <strong>Bhantham Matrimony</strong> is a trusted platform dedicated
            to helping individuals find their perfect life partner. We believe
            that marriage is not just a union of two people but a bond of two
            families, cultures, and values.
          </p>
          <p>
            Our mission is to simplify the matchmaking process with authenticity,
            transparency, and respect for traditions while embracing modern
            technology. Whether you are looking for a match within your
            community or across cultures, <strong>Bhantham Matrimony</strong>{" "}
            provides a safe and secure space to connect.
          </p>
          <p>
            With our growing network and personalized support, we are committed
            to guiding you towards finding your right match with confidence and
            happiness.
          </p>
        </div>
      </div>
    </div>
    <Footer/>

    </div>
  );
};

export default AboutUs;
